import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "hooks/morning/axiosInstanse";

interface NoticesDetailRequest {
    category: string;
    list_no: number;
}

export interface NoticesDetailResponseData {
    b_file: string;
    contents: string;
    flag: boolean;
    list_no: number;
    nextList: { list_no: number; subject: string; M_ID: string };
    prevList: any;
    subject: string;
    w_date: string;
}

export const useGetNoticeDetail = ({ category, list_no }: NoticesDetailRequest): UseQueryResult<NoticesDetailResponseData, Error> => {
    let url = enum_api_uri.get_notice_detail.replace(":category", category).replace(":list_no", list_no.toString());
    return useQuery({
        queryKey: ["useGetNoticeDetail", category, list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: !!list_no,
    });
};
